

    /**
     * Returns a copy of the array in reversed order.
     */
    function reverse(array) {
        var copy = array.slice();
        copy.reverse();
        return copy;
    }

    module.exports = reverse;





//////////////////
// WEBPACK FOOTER
// ./~/mout/array/reverse.js
// module id = 1562
// module chunks = 0 1 2